import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
    selector: 'se-tooltip-custom-renderer',
    templateUrl: './tooltip-custom-renderer.component.html',
    styleUrls: ['./tooltip-custom-renderer.component.scss'],
    standalone: false
})
export class TooltipCustomRendererComponent implements ITooltipAngularComp {

    params : Object;

    agInit (params : ITooltipParams<any, any, any>) : void {
        for (let propName in params.data) {
            if (params.data.hasOwnProperty(propName)) {
                this.params = params.data[propName];
            }
        }
    }
   
}
